import { Client } from "./_clientService";

const executeRequest = async (options: any) => {
  try {
    const resp = await new Client(options)[options.method]();
    return resp;
  } catch (error) {
    throw error;
  }
};

async function create(params: any) {
  return executeRequest({
    path: "/platform/create",
    payload: params,
    method: "post",
  });
}

async function update(params: any, platformId: any) {
  return executeRequest({
    path: `/platform/update/${platformId}`,
    payload: params,
    method: "patch",
  });
}

async function getPlatforms(params: any) {
  let payload: any = {
    pageNo: params?.pageNo || 1,
    pageSize: params?.pageSize || 10,
    sortDirection: params?.sortDirection || -1,
    sortBy: params?.sortBy || "createdAt",
    search: params?.search ?? "",
  };

  if (params?.skipPagination) payload["skipPagination"] = true;

  const urlParams = new URLSearchParams(payload).toString();

  return executeRequest({
    path: `/platform/list?${urlParams}`,
    method: "get",
  });
}

async function getPlatformInfo(platformId: any) {
  if (!platformId) throw new Error("No platform id provided");

  return executeRequest({
    path: `/platform/info/${platformId}`,
    method: "get",
  });
}

async function revealPlatformPassword(platformId: any) {
  if (!platformId) throw new Error("No platform id provided");

  return executeRequest({
    path: `/platform/password/${platformId}`,
    method: "get",
  });
}

async function getPlatformSecretPaths(platformId: any) {
  if (!platformId) throw new Error("No platform id provided");

  return executeRequest({
    path: `/platform/secret-paths/${platformId}`,
    method: "get",
  });
}

async function revealPlatformSecret(platformId: any, path: string[]) {
  if (!platformId) throw new Error("No platform id provided");

  return executeRequest({
    path: `/platform/secret/${platformId}?path=${encodeURIComponent(JSON.stringify(path))}`,
    method: "get",
  });
}

export async function updatePlatformStatus(platformId: any) {
  const response = await new Client({
    path: `/platform/update/status/${platformId}`,
  }).patch();

  return response;
}

export async function deletePlatform(platformId: any) {
  const response = await new Client({
    path: `/platform/delete/${platformId}`,
  }).delete();

  return response;
}

async function generateHexSecret() {
  return executeRequest({
    path: "/platform/generate-hex-secret",
    method: "get",
  });
}

async function getPlatformNames() {
  return executeRequest({
    path: "/platform/names",
    method: "get",
  });
}

export {
  create,
  update,
  getPlatforms,
  getPlatformInfo,
  revealPlatformPassword,
  getPlatformSecretPaths,
  revealPlatformSecret,
  generateHexSecret,
  getPlatformNames,
};
